import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar, Download, Users } from "lucide-react";
import { PageHero } from "./About";
import { QuickFactsCard } from "./campus-life/CampusLifePageParts";

const activityRows = [
  ["01", "Blood Donation Camp On the eve of the Birth Anniversary of Shri. R V Deshpande", "16/03/2026"],
  ["02", "Health Awareness Program for Senior Citizens", "01/07/2025"],
  ["03", "International Yoga Day Celebrated at KLS VDIT, Haliyal", "21/06/2025"],
  ["04", "NSS Community Service Activity: Painting Work of Mavinkoppa Hanuman Temple", "02/01/2026"],
  ["05", "Assessment of Rural Government School Children by KLS VDIT NSS Volunteers in Association with Cherysh NGO", "04/03/2025"],
  ["06", "The Staff Self-Enumeration Process at KLS VDIT", "09/04/2026"],
  ["07", "National Voters' Day Celebrated at KLS VDIT, Haliyal", "25/01/2025"],
  ["08", "Yoga Training for School Students by KLS VDIT", "18/06/2025"],
];

const activities = [
  {
    title: "Blood Donation Camp On the eve of the Birth Anniversary of Shri. R V Deshpande",
    description:
      "A voluntary blood donation drive conducted to promote social responsibility, community service, and healthcare support.",
    report: "#",
  },
  {
    title: "Health Awareness Program for Senior Citizens",
    description:
      "An outreach programme aimed at creating awareness among senior citizens regarding health, wellness, and preventive healthcare practices.",
    report: "#",
  },
  {
    title: "International Yoga Day Celebrated at KLS VDIT, Haliyal",
    description:
      "A yoga awareness and practice session conducted to promote physical fitness, mental well-being, and healthy living.",
    report: "#",
  },
  {
    title: "NSS Community Service Activity: Painting Work of Mavinkoppa Hanuman Temple",
    description:
      "A community service initiative undertaken by NSS volunteers to support local heritage and public infrastructure through painting and maintenance activities.",
    report: "#",
  },
  {
    title: "Assessment of Rural Government School Children by KLS VDIT NSS Volunteers in Association with Cherysh NGO",
    description:
      "An educational outreach programme involving assessment and interaction with rural school children to understand and support their learning needs.",
    report: "#",
  },
  {
    title: "The Staff Self-Enumeration Process at KLS VDIT",
    description:
      "An awareness and participation programme encouraging staff involvement in national self-enumeration initiatives.",
    report: "#",
  },
  {
    title: "National Voters' Day Celebrated at KLS VDIT, Haliyal",
    description:
      "An awareness programme promoting democratic values, voter registration, and responsible citizenship.",
    report: "#",
  },
  {
    title: "Yoga Training for School Students by KLS VDIT",
    description:
      "A training programme conducted for school students to encourage yoga, fitness, discipline, and holistic well-being.",
    report: "#",
  },
];

const quickFacts = [
  ["Category", "Student Clubs"],
  ["Club", "National Service Scheme (NSS)"],
  ["Focus", "Community Service & Social Responsibility"],
  ["Activity Year", "2025-26"],
  ["Activities Conducted", "8"],
  ["Reports Available", "8"],
  ["Major Event", "Blood Donation Camp"],
  ["Community Outreach", "Rural Schools & Senior Citizens"],
];

const NSS = () => (
  <main>
    <PageHero
      title="National Service Scheme (NSS)"
      sub="Community service, social responsibility, leadership, and nation-building through student engagement"
      image="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=2400&q=80"
    />

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
      <Link
        to="/clubs"
        className="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:underline mb-8"
      >
        <ArrowLeft size={16} />
        Back to Clubs
      </Link>

      <div className="grid lg:grid-cols-3 gap-8 items-start">
        <section className="lg:col-span-2 bg-white border border-brand/15 p-7 md:p-9">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 border border-brand/20 flex items-center justify-center text-brand">
              <Users size={22} />
            </div>
            <p className="text-xs uppercase tracking-[0.24em] text-brand font-semibold">
              National Service Scheme
            </p>
          </div>

          <h2
            className="text-3xl md:text-5xl text-brand font-semibold leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            NSS 2025-26 Activities Conducted
          </h2>

          <p className="mt-5 text-[16px] text-[#2a2a2a]/85 leading-relaxed">
            The National Service Scheme (NSS) promotes social responsibility, community engagement, leadership, environmental awareness, and nation-building through student participation in outreach and service activities.
          </p>
        </section>

        <aside className="space-y-5 lg:sticky lg:top-32">
          <div className="bg-white border border-brand/15 p-5">
            <QuickFactsCard facts={quickFacts} />
          </div>

        
        </aside>
      </div>

      <section className="mt-12">
        <div className="bg-white border border-brand/15 overflow-hidden">
          <div className="text-center px-4 py-5">
            <h3 className="text-2xl md:text-3xl text-brand font-bold underline">
              NSS CLUB
            </h3>
            <p className="text-2xl md:text-3xl text-brand font-bold underline mt-1">
              2025-26
            </p>
            <p className="text-2xl md:text-3xl text-brand font-bold underline mt-1">
              Activity conducted
            </p>
          </div>
          <table className="w-full table-fixed border-collapse text-sm md:text-base">
            <thead>
              <tr className="bg-surface-alt/70">
                <th className="w-16 border border-brand/30 px-3 py-2 text-left">
                  Sl. No
                </th>
                <th className="border border-brand/30 px-3 py-2 text-left">
                  Activity
                </th>
                <th className="w-32 border border-brand/30 px-3 py-2 text-left">
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              {activityRows.map(([serial, initiative, date]) => (
                <tr key={serial}>
                  <td className="border border-brand/30 px-3 py-2 align-top font-semibold">
                    {serial}
                  </td>
                  <td className="border border-brand/30 px-3 py-2 align-top">
                    {initiative}
                  </td>
                  <td className="border border-brand/30 px-3 py-2 align-top">
                    {date}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="mt-12">
        <p className="text-xs uppercase tracking-[0.24em] text-brand font-semibold mb-4">
          Activities
        </p>
        <div className="grid md:grid-cols-2 gap-5">
          {activities.map((activity) => (
            <article key={activity.title} className="bg-white border border-brand/15 p-5">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 border border-brand/20 flex items-center justify-center text-brand flex-shrink-0">
                  <Calendar size={18} />
                </div>
                <div>
                  <h3 className="text-xl text-brand font-semibold leading-snug">
                    {activity.title}
                  </h3>
                  <p className="text-sm text-[#2a2a2a]/85 leading-relaxed mt-2">
                    {activity.description}
                  </p>
                  <a
                    href={activity.report}
                    download
                    className="inline-flex items-center gap-2 mt-4 bg-brand text-white px-4 py-2 text-xs font-semibold tracking-wider uppercase hover:bg-brand-dark transition"
                  >
                    <Download size={14} />
                    Download report
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </section>
  </main>
);

export default NSS;